import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import WatchVideosCreateEditForm from './Components/WatchVideosCreateEditForm';
import WatchVideosApi from './WatchVideosApi';
import moment from 'moment';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: WatchVideosCreateEditForm,
                getCreate: WatchVideosApi.create,
                getClone: WatchVideosApi.getOne,
                defaults: { date: moment().format(), type: "playback", video: {} },
                successMessage: "Video Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}